import { createSelector } from 'reselect';
import { RootState } from '../../../rootReducer';
import { NewFindingStatus, ShapePoint } from '../Annotation/annotation.types';
import { getSeverityPropValue } from '../Annotation/Helpers';

export type AnnotatedFinding = {
  id: string;
  shape: ShapePoint[];
  homographyShape: ShapePoint[];
  isMlProposal: boolean;
  isReviewed: boolean;
  isQaReviewed: boolean;
  dirty: boolean;
  disabled: boolean;
  severity?: number;
  visible?: boolean;
};

const getGrid = (state: RootState) => state.annotation.annotationsGrid;
const getSelectedName = (state: RootState) => state.annotation.selectedName;
const getSelectedSequencePath = (state: RootState) => state.annotation.sequencePath;

export const prepareShapesSelector = createSelector([getGrid, getSelectedName, getSelectedSequencePath], (gridData, selectedName, sequencePath) => {
  if (!gridData) {
    return null;
  }

  let annotations: AnnotatedFinding[] = [];

  gridData
    .filter(x => x.sequencePath === sequencePath && x.imageName === selectedName)
    .forEach(element => {
      let newData: AnnotatedFinding = {} as AnnotatedFinding;
      newData.isMlProposal = element.isMlProposal;
      newData.isReviewed = element.isReviewed;
      newData.isQaReviewed = element.isQaReviewed;
      newData.id = element.id;
      newData.shape = element.shape;
      newData.homographyShape = element.homographyShape;
      newData.dirty = element.dirty;
      newData.disabled = element.newStatus === NewFindingStatus.AssessmentCompleted;
      newData.visible = element.visible;
      newData.severity = getSeverityPropValue(element);
      annotations.push(newData);
    });

  return annotations;
});
